import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('script?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('script/show/'+id);
    },    
    create(params) {
        return Service().post('script/create', params);
    },
    update(id, params) {
        return Service().post('script/update/'+id, params);
    },
    delete(id) {
        return Service().post('script/delete/'+id);
    },
}